import { render, staticRenderFns } from "./ExpansionTitle.vue?vue&type=template&id=a61b9c88&scoped=true&"
import script from "./ExpansionTitle.vue?vue&type=script&lang=js&"
export * from "./ExpansionTitle.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionTitle.vue?vue&type=style&index=0&id=a61b9c88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61b9c88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpandTransition,VIcon,VRow})
